import { collection, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import db, { realtimeDB } from "../Backend";
import Chapterunitlist from "./Chapterunitlists";
import { getChapterUnitName, initDB, saveChapterUnitName } from "../ConfigureIndexedDB";
import { get, ref } from "firebase/database";
import { Link, useNavigate } from "react-router-dom";

const AuthUser = ({tokenvalue}) => {
    const [userName,setName]=useState("");
    const [chapterName,setChapterName]=useState("");
    const [unitName,setUnitName]=useState("");
    const [authKey,setAuthkey]=useState("");
    const [allLocations,setAllLocations]=useState([]);
    const [tries,setNumberofTries]=useState(4);
    const [timeup,setTimeup]=useState(false);
    const [wrongKey,setWrongKey]=useState("");
    const navigate = useNavigate();
   
    
   

    useEffect(()=>{
        const collectionRef = collection(db,"reports");
        const unsub = onSnapshot(collectionRef, (snapshot)=>{
            const items = [];
            snapshot.forEach((doc)=>{
                items.push(doc.data());
            })
            setAllLocations(items);
        });
        return unsub;
    },[]);

    useEffect(()=>{
        initDB().then(()=>{
            getChapterUnitName("cun")
            .then((data)=>{
                if(data){
                    setChapterName(data.chapter_name);
                    setUnitName(data.unit_name);
                    setName(data.user_name && data.user_name);
                }
            }).catch((err)=>{
                console.log(err);
            });
        }).catch((err)=>{
            console.log(err);
        });

    },[]);

    const namefromchild=(unit_name,chapter_name)=>{
        setChapterName(chapter_name);
        setUnitName(unit_name);
    };

    const storeusername=()=>{
        initDB().then(()=>{
            saveChapterUnitName({
                id: "cun",
                unit_name: unitName,
                chapter_name: chapterName,
                user_name: userName
            }).then((res)=>{
                if(res === true){
                  sessionStorage.setItem("token","verified");
                  const tvalue = sessionStorage.getItem("token");
                  tokenvalue(tvalue); 
                  console.log(tvalue);
                 const timeid = setTimeout(() => {
                    navigate("/report/form");
                  }, 500);
                  return ()=> clearTimeout(timeid);
                }
            }).catch((err)=>{
                console.log(err);
            })
        }).catch((err)=>{
            console.log(err);
        });
    };

    useEffect(()=>{
        if(authKey === ""){
            try{
            sessionStorage.removeItem("token");
            tokenvalue("");
            }catch{

            }
        }
    },[authKey,tokenvalue]);

    const storeChapterdetails=()=>{
        initDB().then(()=>{
            saveChapterUnitName({
                id: "cun",
                unit_name: unitName,
                chapter_name: chapterName,
                user_name: userName
            }).then((res)=>{
                if(res === true){
                    sessionStorage.setItem("token","verified");
                    const tvalue = sessionStorage.getItem("token");
                    tokenvalue(tvalue); 
                   const timeid = setTimeout(() => {
                    navigate(`/chapter_dashboard/${chapterName}`);
                    }, 500);
                    return ()=> clearTimeout(timeid);
                }
            }).catch((err)=>{
                console.log(err);
            })
        }).catch((err)=>{
            console.log(err);
        })
    };

    const verifyauthkey=async(e)=>{
        e.preventDefault();
        const snapshotkey = await get(ref(realtimeDB,`authkey/${chapterName}/${unitName}`));
        if(snapshotkey.exists()){
            if(snapshotkey.val()===authKey){
                storeusername();
            }else{
                setNumberofTries(prev => prev-1);
                setWrongKey(`Invalid key, you have ${tries-1} attempt`);
            }
        }
    };

    const verifyChapterauthkey=async()=>{
        const snapshotkey = await get(ref(realtimeDB,`authkey/${chapterName}/${chapterName}`));
        if(snapshotkey.exists()){
            if(snapshotkey.val()===authKey){
                storeChapterdetails();
            }else{
                setNumberofTries(prev => prev-1);
                setWrongKey(`Invalid key, you have ${tries-1} attempt`);
            }
        }
    };

    useEffect(()=>{
      const starttime = setTimeout(() => {
            const checktimeup = sessionStorage.getItem("timeup");
            if(checktimeup && checktimeup === "true"){
                setTimeup(true);
               const timeid = setTimeout(() => {
                    setTimeup(false);
                    sessionStorage.setItem("timeup",false);
                    setNumberofTries(4);
                }, 60000);
                return ()=>clearTimeout(timeid);
            }else{
                if(tries === 0){
                    sessionStorage.setItem("timeup",true);
                    setTimeup(true);
                  const timeid = setTimeout(() => {
                        setTimeup(false);
                        sessionStorage.setItem("timeup",false);
                        setNumberofTries(4);
                    }, 60000);
                    return ()=>clearTimeout(timeid);
                }
            }
        }, 2000);
        return()=>clearTimeout(starttime);
    },[tries]);


    return ( 
        <div className="authuser">
            <div style={{width:"100%",display:"flex",justifyContent:"center"}}>
            <div className="authusertop">
                {allLocations && allLocations.map(data =>(
                    <Chapterunitlist 
                        key={data.chapterName}
                        chapterName={data.chapterName}
                        unit1={data.unit1}
                        unit2={data.unit2}
                        unit3={data.unit3}
                        unit4={data.unit4}
                        unit5={data.unit5}
                        unit6={data.unit6}
                        unit7={data.unit7}
                        unit8={data.unit8}
                        unit9={data.unit9}
                        unit10={data.unit10}
                        unitchaptername={namefromchild}
                    />
                ))
                }

            </div>
            </div>


            <div className="authuserbody">
                {!timeup ? 
                    <div className="flex-column2" style={{width:"100%"}}>
                        <form className="flex-column2" onSubmit={verifyauthkey}>
                        <input type="text" placeholder="your name" required value={userName} onChange={e => setName(e.target.value)}/>
                        <input type="text" placeholder="Chapter name" required value={chapterName} onChange={e => setChapterName(e.target.value)}/>
                        <input type="text" placeholder="Unit name" required value={unitName} onChange={e => setUnitName(e.target.value)}/>
                        <input type="text" placeholder="Authorization key"  required value={authKey} onChange={e => setAuthkey(e.target.value)}/>
                        <button>{`Proceed (Unit)`}</button>
                        <h3>{wrongKey}</h3>
                    </form>
                     <button onClick={()=>verifyChapterauthkey()}>{`Proceed (Chapter)`}</button> <br/>
                     <Link to="/unittutorials" >Watch Tuturials on Unit reporting and allocations</Link> <br/>
                     <Link to="/chaptertutorials">Watch Tuturials on Chapter reporting and Chapter queries</Link> <br/>
                    </div>
           
                    :
                    <form>
                        <h2>Auth time out. we were unable to authenticate your key. Try again after some time. To prevent unauthorized  
                            activities, we limit the login attempt to 4 times.
                        </h2>
                    </form>
                }
 
            </div>
       
        </div>
     );
}
export default AuthUser;